import { FunctionComponent } from 'preact';
import './PlaceholderCover.css';

interface PlaceholderCoverProps {
  text: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const PlaceholderCover: FunctionComponent<PlaceholderCoverProps> = ({
  text,
  size = 'medium',
  className = '',
}) => {
  const sizeClass = `placeholder-cover-${size}`;

  return (
    <div className={`placeholder-cover ${sizeClass} ${className}`}>{text}</div>
  );
};
